import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import HelmetComponent from "../../components/shared/Helmet";
import { compose } from "redux";
import { axiosUserManagement } from "../../axios";
import { LoaderComponent } from "../../components/loader";

import {
  IsEmpty,
  reformatDate,
  reformatTime,
  appendFollowStatus,
  followButtonClicked,
  unFollowButtonClicked,
  redirectToCompanyUrl,
  redirectToExpertUrl,
  convertToSlug
} from "../../util/commonFunctions";
import Player from "../../components/shared/Player";
import {
  setSignupModalStatus,
  getEventDataAction,
  hideLoader,
  showLoader
} from "../../actions";
import Modal from "../../components/shared/Modal";
import QuestionPopup from "../../components/eventQuestion/questionPopup";
import { getEnv } from "../../../helpers/env";
import { handleActionError } from "../../util/error";

class WebinarRegistrationPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isloggedin: false,
      isOpen: false,
      redirect: false,
      showQuestionPopup: false,
      eventQuestion: [],
      companies:  !IsEmpty(this.props.eventDetails) && this.props.eventDetails.companyVOs != null ? this.props.eventDetails.companyVOs : [],
      experts:  !IsEmpty(this.props.eventDetails) && this.props.eventDetails.expertVOs != null ? this.props.eventDetails.expertVOs : [],
      isLoading: false
    }
    this.openModal = this.openModal.bind(this);
    this.quesModalToggle = this.quesModalToggle.bind(this);
    this.appendFollowCompanyStatusRespHandler = this.appendFollowCompanyStatusRespHandler.bind(this);
    this.appendFollowExpertStatusRespHandler = this.appendFollowExpertStatusRespHandler.bind(this);
    if (typeof window !== 'undefined') {
      if (localStorage.getItem("token")) {
        if (this.state.companies && this.state.companies?.length > 0) {
          appendFollowStatus(this.appendFollowCompanyStatusRespHandler, localStorage.getItem("token"), this.state.companies, true);
        }
        if (this.state.experts && this.state.experts?.length > 0) {
          appendFollowStatus(this.appendFollowExpertStatusRespHandler, localStorage.getItem("token"), this.state.experts, false, false, true);
        }
      }
    }
  }

  openModal() {
    this.setState({ isOpen: true })
  }

  quesModalToggle() {
    this.setState({ showQuestionPopup: !this.state.showQuestionPopup });
  }

  componentDidMount() {
    if (!IsEmpty(localStorage.getItem("token"))) {
      this.setState({
        isloggedin: true
      });
      if (!IsEmpty(localStorage.getItem("followObject"))) {
        let objectId = JSON.parse(localStorage.getItem("followObject")).objectId;
        let objectType = JSON.parse(localStorage.getItem("followObject")).objectType;
        if (objectType == "company" || objectType == "expert") {
          this.followObject(objectId, objectType);
          localStorage.removeItem("followObject");
        }
        localStorage.removeItem("userLastKnownLocation");
      } else if (!IsEmpty(localStorage.getItem("userLastKnownLocation")) && decodeURIComponent(localStorage.getItem("userLastKnownLocation")) == getEnv("BASE_URL") + this.props.match.url) {
        localStorage.removeItem("userLastKnownLocation");
        localStorage.removeItem("askOnboardingQues");
        this.fetchQuestionForEvent();
      }
    }
    this.id = setTimeout(() => this.setState({ redirect: true }), 2000)
  }

  componentWillUnmount() {
    clearTimeout(this.id)
  }

  openSigninModalPopup = (requestedForm) => {
    this.props.setSignupModalStatus(true, requestedForm);
  };

  registerUserForEvent = () => {
    this.setState({
      isLoading: true
    });
    const isUpcomingEvent = this.isEventRegistrationAllowed(this.props.eventDetails?.endTime);
    let config = {
      headers: {
        "cache-control": "no-cache",
        "content-type": "application/json"
      }
    };
    let reqBody = {
      "eventId": this.props.eventDetails.id,
      "jwtToken": localStorage.getItem("token")
    }
    axiosUserManagement
      .post("/subscriber/webinar/registration", reqBody, { ...config })
      .then(res => {
        if (res.status == 200) { // success response
          this.setState({
            isLoading: false
          });
          if (isUpcomingEvent) {
            this.props.history.push({
              pathname: '/events/success',
              state: {
                eventUrl: res.data.data.webinarUrl,
                eventDetails: this.props.eventDetails
              }
            });
          } else {
            window.location.href = res.data.data.webinarUrl;
          }
        }
      })
      .catch(err => {
        handleActionError("Error subscribing to webinar:", err);
        if (err.response.status == 400) { // user already registered
          this.setState({
            isLoading: false
          });
          if (isUpcomingEvent) {
            this.props.history.push({
              pathname: '/events/success',
              state: { eventUrl: res.data.data.webinarUrl }
            });
          } else {
            window.location.href = res.data.data.webinarUrl;
          }

        }
        else {
          this.setState({
            isLoading: false
          });
          console.log(err);
          alert('Unable to register, please check later');
        }
      });
  };

  saveQuestionResponses = (questionResponses = []) => {
    if (questionResponses.length > 0) {
      let config = {
        headers: {
          "cache-control": "no-cache",
          "content-type": "application/json"
        }
      };
      let reqBody = {
        "questionResponseList": questionResponses,
        "jwt": localStorage.getItem("token")
      }
      axiosUserManagement
        .post("/subscriber/question/responses/save", reqBody, { ...config })
        .then(res => {
          if (res.status == 200) { // success response
            this.registerUserForEvent();
          }
        })
        .catch(err => {
          handleActionError("Error saving question responses:", err);
          alert('Unable to save responses, please check back later');
        });
    } else {
      this.registerUserForEvent();
    }
  };

  fetchQuestionForEvent = () => {
    let config = {
      headers: {
        "cache-control": "no-cache",
        "content-type": "application/json"
      }
    };
    let reqBody = {
      "eventId": this.props.eventDetails.id,
      "jwtToken": localStorage.getItem("token")
    }
    axiosUserManagement
      .post("/subscriber/question/fetch", reqBody, { ...config })
      .then(res => {
        var apiResp = res.data;
        if (apiResp.length > 0) {
          this.quesModalToggle();
          this.setState({ eventQuestion: apiResp })
        } else {
          this.registerUserForEvent();
        }
      })
      .catch(err => {
        handleActionError("Error fetching subscriber questions:", err);
        alert('Unable to fetch questions, please check later');
      });
  };

  getTnChtml = (content) => {
    content = content.replace('<p><br></p>', '');
    content = content.replace(/<p/g, '<p class="description" ');
    content = content.replace(/<a/g, '<a class="custom_links_webinar" ');
    content = content.replace(/<li/g, '<li class="default_listing description" ');
    content = content.replace(/<ul/g, '<ul class="default_listing" ');
    content = content.replace(/<ol/g, '<ol class="default_listing" ');
    content = content.replace(/<img/g, '<img class="responsive-img" ');
    return {
      __html: content
    };
  };

  isEventRegistrationAllowed = (endUnixTime) => {
    let isAllowed = true;
    let currentUnixTime = + new Date();
    if (currentUnixTime >= endUnixTime) {
      isAllowed = false;
    }
    return isAllowed;  ////pending enable this
    // return true;
  };

  appendFollowCompanyStatusRespHandler = (response, error) => {
    this.setState({
      companies: response
    });
  }

  appendFollowExpertStatusRespHandler = (response, error) => {
    this.setState({
      experts: response
    });
  }

  followButtonClickedRespHandler = (response, error) => {
    this.updateFollowBtnStatus(response.objectId, response.objectType);
  }

  unFollowButtonClickedRespHandler = (response, error) => {
    this.updateFollowBtnStatus(response.objectId, response.objectType);
  }

  followObject = (objectId, objectType) => {
    if (localStorage.getItem("token")) {
      if (objectType == "company") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), objectId);
      } else if (objectType == "expert") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
      }
    } else {
      let followObject = { objectId: objectId, objectType: objectType };
      localStorage.setItem("followObject", JSON.stringify(followObject));
      this.openSigninModalPopup("signin");
    }
  }

  unFollowObject = (objectId, objectType) => {
    if (objectType == "company") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), objectId);
    } else if (objectType == "expert") {
      unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
    }
  }

  updateFollowBtnStatus = (objectId, objectType) => {
    if (this.state.companies.length > 0 && objectType == "company") {
      let updated_companies = [];
      Object.values(this.state.companies).map(values => {
        if (values?.id == objectId) {
          values.isFollowed = !values.isFollowed;
        }
        updated_companies.push(values);
      });
      this.setState({
        companies: updated_companies
      });
    } else if (this.state.experts.length > 0 && objectType == "expert") {
      let updated_experts = [];
      Object.values(this.state.experts).map(values => {
        if (values?.id == objectId) {
          values.isFollowed = !values.isFollowed;
        }
        updated_experts.push(values);
      });
      this.setState({
        experts: updated_experts
      });
    }
  }

  renderExpertCompSection = () => {
    let expertOrCompanyExist = this.props?.eventDetails.expertVOs != null || this.props?.eventDetails.companyVOs != null;
    if (expertOrCompanyExist) {
      return (
        <div className="expert-section">
          <div className="container">
            <div className="row">
              {this.props?.eventDetails.expertVOs != null && this.props?.eventDetails.expertVOs?.length != 0 &&
                <div className="col-12 col-md-6 margin_bottom40">
                  <h3>Experts you’ll hear from</h3>
                  <ul>
                    {this.props?.eventDetails.expertVOs.map(function (item, i) {
                      return (
                        <>
                          <div className="expert-slider-item max_width65">
                            <div className="expert-item">
                              <div className="expert-img">
                                <a
                                  href={`/expert/${item.name}/${item.id}`}
                                  onClick={event => {
                                    redirectToExpertUrl(
                                      event,
                                      item.id,
                                      item.name,
                                      this.props,
                                      this.props.showLoader,
                                      this.props.hideLoader
                                    )
                                  }
                                  }
                                >
                                  {item.imageSrc &&
                                    <img src={item.imageSrc} style={{ maxWidth: "100%" }} alt={item.name} />
                                  }
                                  {!item.imageSrc &&
                                    <img src="/assets/commbank.png" style={{ maxWidth: "100%" }} alt={item.name} />
                                  }
                                </a>

                              </div>
                              <div className="expert-info" >
                                <a
                                  href={`/expert/${item.name}/${item.id}`}
                                  onClick={event => {
                                    redirectToExpertUrl(
                                      event,
                                      item.id,
                                      item.name,
                                      this.props,
                                      this.props.showLoader,
                                      this.props.hideLoader
                                    )
                                  }
                                  }
                                >
                                  <h4 >{item.name}</h4>
                                  <span >{item?.industry}</span>
                                </a>
                              </div>
                              <div className="expert-follow" >
                                <a href="javascript:void(null);" className={this.state.experts[i].isFollowed ? "expert-follow-btn hide" : "expert-follow-btn"} onClick={() => this.followObject(item.id, 'expert')}>Follow</a>
                                <a href="javascript:void(null);" className={!this.state.experts[i].isFollowed ? "expert-unfollow-btn hide" : "expert-unfollow-btn"} onClick={() => this.unFollowObject(item.id, 'expert')}>Following</a>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    }, this)
                    }
                  </ul>
                </div>
              }
              {this.props?.eventDetails.companyVOs != null && this.props?.eventDetails.companyVOs?.length != 0 &&
                <div className="col-12 col-md-6">
                  <h3>Featured Companies</h3>
                  <ul>
                    {this.props?.eventDetails.companyVOs.map(function (item, i) {
                      return (
                        <>
                          <div className="expert-slider-item max_width65" >
                            <div className="expert-item" >
                              <div className="expert-img">
                                <a
                                  href={`/company/${item.name}/${item.id}`}
                                  onClick={event => {
                                    redirectToCompanyUrl(
                                      event,
                                      item.id,
                                      item.name,
                                      this.props,
                                      this.props.showLoader,
                                      this.props.hideLoader
                                    )
                                  }
                                  }
                                >
                                  {item.imageSrc &&
                                    <img src={item.imageSrc} style={{ maxWidth: "100%" }} alt={item.name} />
                                  }
                                  {!item.imageSrc &&
                                    <img src="/assets/commbank.png" style={{ maxWidth: "100%" }} alt={item.name} />
                                  }
                                </a>

                              </div>
                              <div className="expert-info" >
                                <a
                                  href={`/company/${item.name}/${item.id}`}
                                  onClick={event => {
                                    redirectToCompanyUrl(
                                      event,
                                      item.id,
                                      item.name,
                                      this.props,
                                      this.props.showLoader,
                                      this.props.hideLoader
                                    )
                                  }
                                  }
                                >
                                  <h4 >{item.name}</h4>
                                  <span >{item.industry}</span>
                                </a>
                              </div>
                              <div className="expert-follow" >
                                <a href="javascript:void(null);" className={this.state.companies[i].isFollowed ? "expert-follow-btn hide" : "expert-follow-btn"} onClick={() => this.followObject(item.id, 'company')}>Follow</a>
                                <a href="javascript:void(null);" className={!this.state.companies[i].isFollowed ? "expert-unfollow-btn hide" : "expert-unfollow-btn"} onClick={() => this.unFollowObject(item.id, 'company')}>Following</a>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    }, this)
                    }
                  </ul>
                </div>
              }
            </div>
          </div>
        </div>
      );
    }
  }




  render() {

    if (this.props.eventDetails && Object.keys(this.props.eventDetails).length === 0 && this.props.eventDetails.constructor === Object || this.props.eventDetails == null) {

      // return this.state.redirect
      // ? <Redirect to='/' />
      // : <div class="alert alert-warning text-center">
      //        This event no longer exists.
      //      </div>
      return <div class="alert alert-warning text-center">This event no longer exists.</div>
    }

    let eventRegistrationAllowed = this.isEventRegistrationAllowed(this.props.eventDetails?.endTime);


    let videoUrl = { dash: null, hls: null, progressive: null };
    if (this.props.eventDetails.previewUrl) {
      videoUrl.progressive = this.props.eventDetails?.previewUrl; // set videoUrl json mp4 path
    }

    let displayLayout = 1;

    if (!IsEmpty(videoUrl.progressive) || !IsEmpty(this.props.eventDetails.eventImageSource)) {
      displayLayout = 2;
    }

    return (
      <React.Fragment>
        <LoaderComponent isLoading={this.state.isLoading} />
        <Modal
          openPopup={this.state.isOpen}
          resetPopupProps={() => this.setState({ isOpen: false })}
          modalID="playerPopUp"
          key={this.state.isOpen}
        >
          <>
            <div className="event-player">
              <img
                className="event-close-white cross cursor_pointer"
                src="/assets/svg/cross.svg"
                onClick={() => this.setState({ isOpen: false })}
              />
              <React.Fragment>
                <Player
                  videoUrl={videoUrl}
                  eventPreview="true"
                />
              </React.Fragment>
            </div>
          </>
        </Modal>
        {!IsEmpty(this.props.eventDetails.title) &&
          <HelmetComponent
            title={
              this.props.eventDetails.title
            }
            description={
              this.props.eventDetails.description
            }
            keywords={
              this.props.eventDetails.keywords
                ? this.props.eventDetails.keywords
                : ''
            }
            thumbnailImage={
              this.props.eventDetails.eventImageSource
                ? this.props.eventDetails.eventImageSource
                : ''
            }
            noIndex="false"
          />
        }
        <div className="wrapper_homePage">
          <section className="banner">
            <div className="container">
              <section className="header">
                <a href={getEnv("BASE_URL")}>
                  <img src="/assets/ausbizLogo.png" alt="Ausbiz" />
                </a>
                {this.props?.eventDetails.sponsorLogosSource &&
                  <div className="sponser web_design">
                    <span className="sponser_title">Brought to you by</span>
                    <ul>
                      {this.props?.eventDetails.sponsorLogosSource.map(function (item, i) {
                        return (
                          <>
                            <li key={`sponsor${i}`}>
                              <img src={item} />
                            </li>
                          </>
                        );
                      })
                      }
                    </ul>
                  </div>
                }
              </section>
              {displayLayout == 1 && (
                <div className="row" >
                  <div className="col-12">
                    {this.props?.eventDetails?.series &&
                      <div className="img-with-text" >
                        <Link
                          to={{
                            pathname: `/series/${convertToSlug(this.props?.eventDetails?.series.name)}?seriesID=${this.props?.eventDetails?.series.id}`,
                          }}
                          target="_blank"
                        >
                          {!IsEmpty(this.props.eventDetails.series.imageSrc) &&
                            <img src={this.props.eventDetails.series.imageSrc} alt="Series Logo" />
                          }
                          {IsEmpty(this.props.eventDetails.series.imageSrc) &&
                            <img src="/assets/ausbiz_series_logo.png" alt="Series Default Logo" />
                          }
                          <span>{this.props?.eventDetails?.series.name}</span>
                        </Link>
                      </div>
                    }
                    {/* {this.props?.eventDetails?.series &&
                      <span className="banner_subTitle">{this.props.eventDetails.series}</span>
                    } */}
                    {this.props?.eventDetails?.title &&
                      <h2>{this.props.eventDetails.title}</h2>
                    }
                    {this.props?.eventDetails?.description &&
                      <span className="banner_note">{this.props.eventDetails.description}</span>
                    }
                    {this.props?.eventDetails.sponsorLogosSource &&
                      <div className="sponser mob_design">
                        <span className="sponser_title">Brought to you by</span>
                        <ul>
                          {this.props?.eventDetails.sponsorLogosSource.map(function (item, i) {
                            return (
                              <>
                                <li key={`sponsorImg${i}`}>
                                  <img src={item} />
                                </li>
                              </>
                            );
                          })
                          }
                        </ul>
                      </div>
                    }
                  </div>
                </div>
              )}
              {displayLayout == 2 && (
                <div className="row banner_with_video">
                  <div className="col-12 col-md-6 pR60 mP24">
                    {this.props?.eventDetails?.series &&
                      <div className="img-with-text" >
                        <Link
                          to={{
                            pathname: `/series/${convertToSlug(this.props?.eventDetails?.series.name)}?seriesID=${this.props?.eventDetails?.series.id}`,
                          }}
                          target="_blank"
                        >
                          {!IsEmpty(this.props.eventDetails.series.imageSrc) &&
                            <img src={this.props.eventDetails.series.imageSrc} alt="Series Logo" />
                          }
                          {IsEmpty(this.props.eventDetails.series.imageSrc) &&
                            <img src="/assets/ausbiz_series_logo.png" alt="Series Default Logo" />
                          }
                          <span>{this.props?.eventDetails?.series.name}</span>
                        </Link>
                      </div>
                    }
                    {/* {this.props?.eventDetails?.series &&
                      <span className="banner_subTitle">{this.props.eventDetails.series}</span>
                    } */}
                    {this.props?.eventDetails?.title &&
                      <h2>{this.props.eventDetails.title}</h2>
                    }
                    {this.props?.eventDetails?.description &&
                      <span className="banner_note">{this.props.eventDetails.description}</span>
                    }
                    {this.props?.eventDetails.sponsorLogosSource &&
                      <div className="sponser mob_design">
                        <span className="sponser_title">Brought to you by</span>
                        <ul>
                          {this.props?.eventDetails?.sponsorLogosSource.map(function (item, i) {
                            return (
                              <>
                                <li key={`sponsorWithVideoImg${i}`}>
                                  <img src={item} />
                                </li>
                              </>
                            );
                          })
                          }
                        </ul>
                      </div>
                    }
                  </div>
                  <div className="col-12 col-md-6">
                    <div className={!IsEmpty(videoUrl.progressive) ? "banner_video cursor_pointer" : "banner_video"} onClick={!IsEmpty(videoUrl.progressive) ? this.openModal : ''} >
                      <img src={this.props.eventDetails.eventImageSource ? this.props.eventDetails.eventImageSource : "/assets/ausbiz_generic_event.jpg"} />
                      {!IsEmpty(videoUrl.progressive) &&
                        <span className="play_btn" />
                      }
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
          <div className="registration_section">
            <div className="container">
              <div className="row">
                <div className="col-12 col-md-6 event_details">
                  {eventRegistrationAllowed &&
                    <>
                      <span className="event_date_time">
                        <img src="/assets/calendar.svg" alt="calendar" />
                        {reformatDate(this.props?.eventDetails?.eventDate)}
                      </span>
                      <span className="event_date_time">
                        <img src="/assets/clock.svg" alt="Clock" />
                        {reformatTime(this.props?.eventDetails.startTime)}-{reformatTime(this.props?.eventDetails.endTime)} AEDT
                      </span>
                    </>
                  }
                  {!eventRegistrationAllowed &&
                    <span className="event_date_time">
                      Watch on demand
                    </span>
                  }

                </div>
                <div className="col-12 col-md-6 DalL">
                  {this.state?.isloggedin &&
                    <button className="registration_button" onClick={() => this.fetchQuestionForEvent()}>
                      Register
                    </button>
                  }
                  {!this.state?.isloggedin &&
                    <button className="registration_button" onClick={() => this.openSigninModalPopup("signin")}>
                      Sign in and register
                    </button>
                  }
                  {this.props?.eventDetails?.termsAndConditions &&
                    <span className="button_note" dangerouslySetInnerHTML={this.getTnChtml(this.props.eventDetails.termsAndConditions)}  ></span>
                  }

                </div>
              </div>
            </div>
          </div>

          <div className="about_section">
            <div className="container">
              <div className="row ">
                <div className="col-12 col-md-6">
                  {this.props?.eventDetails?.about &&
                    <>
                      <h3>About this event</h3>
                      <ul>
                        <li>
                          {this.props.eventDetails.about}
                        </li>
                      </ul>
                    </>
                  }
                </div>
                <div className="col-12 col-md-6">
                  {this.props?.eventDetails?.keyPointsTitle &&
                    <h3>{this.props.eventDetails.keyPointsTitle}</h3>
                  }
                  {this.props?.eventDetails?.keyPointsTitle &&
                    <ul>
                      <li>
                        {this.props.eventDetails.keyPointsBody}
                      </li>
                    </ul>
                  }
                </div>
              </div>
            </div>
          </div>

          {!IsEmpty(this.props.eventDetails.agenda) &&
            <div className="about-section-page">
              <div className="container">
                <div className="row ">
                  <div className="col-12">
                    <h3>Agenda</h3>
                    <ul>
                      {this.props?.eventDetails.agenda.map(function (item, i) {
                        return (
                          <li>
                            <strong className="agenda-time">{item.time}</strong>
                            <div className="agendaSummary">
                              <strong>{item.title}</strong>
                              <p>{item.description}</p>
                            </div>
                          </li>
                        );
                      })
                      }
                    </ul>
                    <small className="birdSeed">Agenda is subject to change</small>
                  </div>
                </div>
              </div>
            </div>
          }


          {this.renderExpertCompSection()}
          {eventRegistrationAllowed &&
            <div className="registered_section">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h3>Limited spaces.Register now.</h3>
                    {this.state?.isloggedin &&
                      <button className="registration_button" onClick={() => this.fetchQuestionForEvent()}>
                        Register
                      </button>
                    }
                    {!this.state?.isloggedin &&
                      <button className="registration_button" onClick={() => this.openSigninModalPopup("signin")}>
                        Sign in and register
                      </button>
                    }
                    {this.props?.eventDetails?.termsAndConditions &&
                      <span className="button_note" dangerouslySetInnerHTML={this.getTnChtml(this.props.eventDetails.termsAndConditions)} ></span>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <QuestionPopup
          allQues={this.state.eventQuestion}
          showQuestionPopup={this.state.showQuestionPopup}
          questionPopupClosedHandler={this.quesModalToggle}
          questionSuccessHandler={this.saveQuestionResponses}
        />
        {/* DO NOT REMOVE THIS BEAMER CODE */}
        <a
          id="callBeamer"
          data-beamer-keypress="true"
          style={{ visibility: "hidden", display: 'none' }}
        >
          What's New
        </a>
      </React.Fragment >
    );
  }
}

const mapStateToProps = state => {
  return {
    eventDetails: state.eventDetails
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLogout: () => dispatch(logout()),
    getEventDataAction: (event_reg_url) => dispatch(getEventDataAction(event_reg_url)),
    setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm)),
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader())
  };
};

function loadData(store, match) {
  let initialLoadData = getEventDataAction(match.params.eventId);
  let actionArray = [store.dispatch(initialLoadData)];
  return actionArray;
}

export default {
  loadData,
  component: compose(connect(mapStateToProps, mapDispatchToProps))(withRouter(WebinarRegistrationPage))
};

